export const blogPosts = [
  {
    slug: 'neluilu-arvaa-nelja-sanaa',
    title: 'Neluilu on täällä: arvaa neljä sanaa kerralla!',
    date: '15.2.2026',
    author: 'Pulmakivi',
    metaDescription: 'Neluilu on suomenkielinen Quordle-peli Norppa-sovelluksessa. Arvaa neljä viisikirjaimista sanaa kerralla – uusi haaste joka päivä!',
    intro: 'Norppa-sovellukseen on lisätty uusi sanapeli: Neluilu. Kyseessä on suomenkielinen versio suositusta Quordle-pelistä, jossa ratkaistaan neljä sanaa samanaikaisesti.',
    sections: [
      {
        title: 'Miten Neluilu toimii?',
        content: `Neluilussa arvaat viisikirjaimisia sanoja, mutta jokainen arvaus näkyy neljässä eri ruudukossa samanaikaisesti. Sinulla on yhdeksän yritystä löytää kaikki neljä piilotettua sanaa. Vihreä tarkoittaa oikeaa kirjainta oikeassa paikassa, keltainen kertoo kirjaimen olevan sanassa mutta väärässä kohdassa.

Peli vaatii enemmän strategiaa kuin yksittäisen sanan arvaaminen, joudut tasapainottelemaan neljän eri ratkaisun välillä jokaisella arvauksella.`,
      },
      {
        title: 'Uusi päivittäinen haaste',
        content: `Neluilussa on uusi peli joka päivä, aivan kuten päivän ristikossa ja Sanailussa. Norppa tarjoaa nyt kolme päivittäistä sanapeliä:`,
        list: [
          'Päivän ristikko – kompakti suomenkielinen sanaristikko',
          'Sanailu – arvaa viisikirjaiminen sana kuudella yrityksellä',
          'Neluilu – arvaa neljä sanaa yhdeksällä yrityksellä',
        ],
        contentAfter: 'Lisää sanapelejä on suunnitteilla.',
      },
    ],
  },
  {
    slug: 'norppa-1000-latausta',
    title: 'Norppa saavutti 1000 latausta – kiitos kaikille pelaajille!',
    date: '7.2.2026',
    author: 'Pulmakivi',
    image: '/ristikkosovellus_puhelin.jpg',
    imageAlt: 'Henkilö pelaa Norppa-ristikkosovellusta puhelimella',
    metaDescription: 'Norppa-ristikkosovellus saavutti yli 1000 latausta alle kuukaudessa. Uusia ominaisuuksia ja parannuksia pelaajien palautteen pohjalta.',
    intro: 'Norppa-ristikkosovellus on saavuttanut 1000 latausta alle kuukaudessa julkaisusta, osoittaen kysynnän suomalaisille sanaristikkosovelluksille.',
    sections: [
      {
        title: 'Kiitos palautteesta',
        content: `Pelaajilta saatu palaute on ollut arvokasta ja pääosin hyvin positiivista. Julkaisun jälkeen sovellusta on paranneltu useilla päivityksillä, joihin kuuluu muun muassa käyttöliittymän visuaaliset parannukset, bugikorjaukset ja käytettävyysparannukset ristikon navigointiin.`,
      },
      {
        title: 'Mitä seuraavaksi?',
        content: `Sovellusta kehitetään jatkuvasti pelaajien toiveiden pohjalta. Tulossa on uusia sanapelejä, parannuksia onboardaukseen ja lisää sisältöä sekä ilmais- että tilaajakäyttäjille. iOS-versio on myös kehitteillä.

Jos et ole vielä kokeillut Norppaa, nyt on hyvä hetki aloittaa. Arkistosta löytyy jo yli sata ristikkoa ratkottavaksi.`,
      },
    ],
  },
  {
    slug: 'norppa-julkaistu',
    title: 'Norppa – uusi suomenkielinen ristikkosovellus on julkaistu!',
    date: '14.1.2026',
    author: 'Pulmakivi',
    image: '/norppa_ristikot.png',
    imageAlt: 'Norppa-ristikkosovellus – suomenkielisiä sanaristikoita mobiilissa',
    metaDescription: 'Norppa on uusi suomenkielinen ristikkosovellus Androidille. Uusi käsinlaadittu ristikko joka päivä, ilmaiseksi. Lataa nyt Google Playsta!',
    intro: 'Norppa on nyt ladattavissa Google Playsta. Kyseessä on yksi ensimmäisistä, suomenkielisille suunnitelluista ristikkosovelluksista, jossa yhdistyvät klassinen sanaristikko ja nykyaikainen käyttökokemus.',
    sections: [
      {
        title: 'Miksi Norppa?',
        content: `Suomenkielisten sanapelien tarjonta sovelluskaupoissa on ollut pitkään heikko. Olemassa olevat vaihtoehdot kärsivät vanhanaikaisista käyttöliittymistä ja puutteellisesta käytettävyydestä. Norppa on rakennettu alusta asti puhelinkäyttöön, riittävän kompakti näytölle, mutta tarpeeksi haastava ollakseen palkitseva.

Norppa on vapaa-ajan projekti, jota olen kehittänyt viiden kuukauden ajan ja laatinut jokaisen ristikon itse. Vihjeet ovat perinteisistä ristikkolehdistä tuttuja sanaleikkejä ja oivaltavia arvoituksia.`,
      },
      {
        title: 'Mitä Norppa tarjoaa?',
        content: `Sovelluksesta löytyy uusi ristikko joka päivä keskiyöllä, täysin ilmaiseksi. Lisäksi mukana on Sanailu: suomenkielinen vastine suositulle Wordle-pelille. Tilaajat pääsevät arkistoon ratkomaan aiempia ristikoita ja pelaavat ilman mainoksia.

Sovellus on suunniteltu mahdollisimman selkeäksi ja helppokäyttöiseksi, jotta se sopii kaikille ristikonystäville iästä riippumatta.`,
      },
    ],
  },
];